import React from "react";
import PropTypes from 'prop-types';
import {get} from './Storage';
import axios from "axios";
import {ClassName} from "mgToolsKit";
import {Message} from "mgUiKit";
import cookie from 'react-cookie';
import css from '../topnews.less';
var AppSettings = get();

class News extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            showBody: false,
            text: "",
            hideNews: false
        }
        this.closeHandle = this.closeHandle.bind(this);
        this.setReadByUserHandle = this.setReadByUserHandle.bind(this);
    }
    componentDidMount(){
      
    }
    
    closeHandle(event){
        this.setState({
            hideNews:true
        });

        var newsId = this.props.id;
        if (typeof(Storage) !== "undefined") {
            var sessionName = AppSettings['env'].sessionName+"_"+newsId;
            sessionStorage.setItem(sessionName, newsId);
        }
        else{
            var cookieName = AppSettings['env'].cookieName+"_"+newsId;
            cookie.save(cookieName, newsId, {path: '/', maxAge:1800});
        }

        this.context.reloadNews();
    }

    setReadByUserHandle(event){
        
        var newsId = this.props.id;
        var url = AppSettings['env'].urlSetReadByuser.replace("[NEWS_ID]", newsId);
        axios.put(url)
            .then(({data, status, statusText}) => {
                if (data.errors.length == 0) {
                    if (typeof(Storage) !== "undefined") {
                        var sessionName = AppSettings['env'].sessionName+"_"+newsId;
                        sessionStorage.setItem(sessionName, newsId);
                    }
                    else{
                        var cookieName = AppSettings['env'].cookieName+"_"+newsId;
                        cookie.save(cookieName, newsId, {path: '/', 
                            maxAge:1800                    
                        });
                    }
                    
                    this.context.reloadNews();
                } 
            })
            .catch(({data, status, statusText}) => {
            });
    }

    render(){
        var idContainer = "top_news_id" + this.props.id;

         var _className = ["news-wrap"];
          if(this.state.hideNews){
            _className.push("hide");
        }else{
            //_className.push("show");
        }
        _className = ClassName(_className);
        var buttonLabel = "";
        var _onClickHandle; 
        if(this.props.hasToBeConfirmed){
            buttonLabel = "Ho letto e accetto";
            _onClickHandle = this.setReadByUserHandle;
        }
        else{
            buttonLabel = "Chiudi";
            if(this.props.setReadByuser && AppSettings.isauthenticated){
                _onClickHandle = this.setReadByUserHandle;
            }
            else{
                _onClickHandle = this.closeHandle;
            }
        }

        var documents = "";
        if (this.props.documents.length > 0) {
            var documents = this.props.documents.map(function (document, i) {
                var key = "document_" + document.id;
                return (
                    <a key={key} className="news-attachment" href={document.url}>
                        <i className="fa fa-paperclip"></i> {document.fileName}
                    </a>
                )
            });
        }

        return(
            <div className={_className}>
                <h2>{this.props.title}</h2>
                <div className="topnews-body" dangerouslySetInnerHTML={{__html: this.props.text}}></div>
                {documents}
                <button onClick={_onClickHandle} type="button" className="mg-button__closeTopNews">{buttonLabel}</button>
            </div>            
        )
    }

    
}

News.displayName = "NewsComponent";

// PropTypes validation
News.propTypes = {
     title: PropTypes.string.isRequired,
     date: PropTypes.string.isRequired,
     id: PropTypes.number.isRequired,
     hasToBeConfirmed: PropTypes.bool.isRequired,
     setReadByuser: PropTypes.bool.isRequired
};

// default props
News.defaultProps = {
};

News.contextTypes = {
    /*
    * Context per identificare l'istanza dellApp
    * */
    reloadNews: PropTypes.func
}

export default News;